import React from 'react'
import { getDateCombination, isImageValidPng } from '../../../../../../commonClass/CommonValidation';

let hotelType = localStorage.getItem('type')?.charAt(0)?.toUpperCase() + localStorage.getItem('type')?.substring(1)?.toLowerCase()

const UploadButton = (props) => {
    const { hotelRoomId,
        mediaType,
        setFormValue,
        hotelId,
        disabled,
        setSave,
        setErrorMessage
    } = props;

    let folderType = mediaType?.charAt(0)?.toUpperCase() + mediaType?.substring(1)?.toLowerCase()

    const handleFileChange = (e) => {
        setErrorMessage({});
        const files = Array?.from(e?.target?.files || []);
        let newFileType = files?.filter((file) => isImageValidPng(file?.name))
        let newFileSize = mediaType === "image" ? newFileType?.filter((file) => ((file?.size / 1024) / 1024) <= 5) : files?.filter((file) => ((file?.size / 1024) / 1024) <= 15)
        let error = {}
        if (files?.length !== newFileType?.length && mediaType === "image") {
            error.imageUpload = 'Only PNG file type is accepted.';
            setErrorMessage(error);
        }
        else if (files?.length !== newFileSize?.length && mediaType === "image") {
            error.imageUpload = 'Cannot upload file that exceeds 5 MB.';
            setErrorMessage(error);
        }
        const imageList = newFileSize?.reduce((acc, file, index) => {
            const filename = getDateCombination(file?.name);
            acc.push({
                HotelMediaId: 0,
                HotelRoomId: hotelRoomId,
                FileName: filename,
                FilePath: `CMS/HotelList/${hotelType}/${hotelId}/${folderType}/${filename}`,
                Path: `CMS/HotelList/${hotelType}/${hotelId}/${folderType}/`,
                File: file,
                MediaType: mediaType === 'image' ? false : true,
                needToUpload: true,
                uploaded: false,
            });

            return acc;
        }, []);

        setFormValue((prev) => [...prev, ...imageList])
        setSave(false)

    };

    return (
        <div className='photo-upload-card w-100 h-100' style={{ backgroundColor: '#0777a926' }}>
            <label
                htmlFor={`multiImage_uploader_AddRoom${hotelRoomId}`}
                className='d-flex justify-content-center align-items-center cursor_pointer bg-transparent h-241px'
            >
                <input
                    type="file"
                    multiple
                    className='d-none'
                    onChange={handleFileChange}
                    id={`multiImage_uploader_AddRoom${hotelRoomId}`}
                    accept={mediaType === 'image' ? '.png' : `${mediaType}/*`}
                    disabled={disabled}
                />

                <div className='text-center py-5'>
                    <div className=''>
                        <span>
                            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M30.8704 33.4582H16.2748C16.842 32.4777 17.1667 31.3392 17.1667 30.1249L30.8704 30.1249V6.79158H10.1296V23.4684C9.05432 23.5272 8.04688 23.841 7.16667 24.3501V6.79158C7.16667 5.87492 7.45679 5.0902 8.03704 4.43742C8.61728 3.78464 9.31481 3.45825 10.1296 3.45825H30.8704C31.6852 3.45825 32.3827 3.78464 32.963 4.43742C33.5432 5.0902 33.8333 5.87492 33.8333 6.79158V30.1249C33.8333 31.0416 33.5432 31.8263 32.963 32.4791C32.3827 33.1319 31.6852 33.4582 30.8704 33.4582ZM29.3889 26.7916H16.2748C15.6065 25.6363 14.6015 24.7002 13.3939 24.1174L16.0556 20.1249L19.3889 25.1249L23.8333 18.4583L29.3889 26.7916ZM15.5 30.1249C15.5 32.8863 13.2614 35.1249 10.5 35.1249C7.73858 35.1249 5.5 32.8863 5.5 30.1249C5.5 27.3635 7.73858 25.1249 10.5 25.1249C13.2614 25.1249 15.5 27.3635 15.5 30.1249ZM10.0238 30.6011H7.16667V29.6487H10.0238V26.7916H10.9762V29.6487H13.8333V30.6011H10.9762V33.4583H10.0238V30.6011Z"
                                    fill="#0777A9"
                                />
                            </svg>
                        </span>
                        <h5 style={{ color: "#0777A9", fontWeight: '700', fontSize: "18px", lineHeight: '27px' }}>Add {mediaType === 'image' ? 'Image' : 'Video'}</h5>
                    </div>
                </div>
            </label>
        </div>
    )
}

export default UploadButton